/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Footer_Madewithsuffix2Inputs */

const ja_playdata_footer_madewithsuffix2 = /** @type {(inputs: Playdata_Footer_Madewithsuffix2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`by PlayBrain ©2016-2024`)
};

const en_playdata_footer_madewithsuffix2 = /** @type {(inputs: Playdata_Footer_Madewithsuffix2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`by PlayBrain ©2016-2024`)
};

/**
* | output |
* | --- |
* | "by PlayBrain ©2016-2024" |
*
* @param {Playdata_Footer_Madewithsuffix2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_footer_madewithsuffix2 = /** @type {((inputs?: Playdata_Footer_Madewithsuffix2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Footer_Madewithsuffix2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_footer_madewithsuffix2(inputs)
	return en_playdata_footer_madewithsuffix2(inputs)
});
export { playdata_footer_madewithsuffix2 as "playdata_footer_madeWithSuffix" }